import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54c0c2da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard__side-mobile" }
const _hoisted_2 = { slot: "bottom-sheet-content" }
const _hoisted_3 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_4 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_5 = { class: "profile-creation-wizard__side-description" }
const _hoisted_6 = { class: "profile-creation-wizard__side-iconTitle" }

import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {getTipsClassPosition} from '@/common/ui/GetTipsClassPosition';
    import {useTranslation} from '@malt/vue3-use';
    import {computed} from 'vue';
    import {onMounted, ref} from 'vue';
    import {useStore} from 'vuex';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeadlineSide',
  setup(__props) {

    const {msg} = useTranslation();
    const store = useStore();

    const tipsClassPosition = getTipsClassPosition(195);
    const headlineSide = ref<HTMLElement>(null);

    onMounted(() => {
        const bottomSheetDisplayer = new BottomSheetDisplayer('', '', headlineSide.value, 'div.profile-creation-wizard');
    });

    const tooltipContent = computed(() => {
        const isStrategy = store.state.isFunnelStrategy;
        return {
            title: msg(
                isStrategy
                    ? 'profile.creation.completion.wizard.v2.details.headline.strategy.help.title'
                    : 'profile.creation.predictor.wizard.details.headline.help',
            ),
            description: msg(
                isStrategy
                    ? 'profile.creation.completion.wizard.v2.details.headline.strategy.help.description'
                    : 'profile.creation.predictor.wizard.details.headline.paragraph.one',
            ),
            icon: isStrategy ? 'megaphone' : 'projectmanager-agile',
        };
    });

return (_ctx: any,_cache: any) => {
  const _component_joy_bottom_sheet = _resolveComponent("joy-bottom-sheet")!
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "headlineSide",
    ref: headlineSide,
    class: "profile-creation-wizard__side"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_joy_bottom_sheet, {
        id: "headline-details-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, _toDisplayString(tooltipContent.value.title), 1),
            _createElementVNode("p", null, _toDisplayString(tooltipContent.value.description), 1)
          ])
        ]),
        _: 1
      }, 8, ["close-label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "profile-creation-wizard__side-container focus",
          style: _normalizeStyle(_unref(tipsClassPosition))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_joy_icon, {
                name: tooltipContent.value.icon,
                size: "small"
              }, null, 8, ["name"]),
              _createElementVNode("strong", null, _toDisplayString(tooltipContent.value.title), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(tooltipContent.value.description), 1)
          ])
        ], 4)
      ])
    ])
  ], 512))
}
}

})